import $ from 'jquery'
import { renderSliderCards } from 'js/sliderCards'

export const renderTabs = (
  $container,
  tabClass,
  callback,
) => {
  if(!$container.length) return

  $container.each(function() {
    const { renderSlider, removeSlider, resizeHandlerInit } = renderSliderCards()
    const $tabs = $container.find(tabClass)
    const $tabsContents = $container.find('.slider-cards')
    const $allSlides = $('.place--item', $container)
    const $contentInitial = $container.find('.tab-1')
    const $contentInitialMobile = $container.find('.mobile-view')
    const $slidesNumberInitial = $contentInitial.find('.place--item')
    let cloneSlides = {}

    const windowWidth = (mq) => {
      if (mq.matches) { //mobile $sm
        cloneSlides = $allSlides.clone()
        const $categories = $container.find('.categories')
        const $contentMob = $contentInitialMobile.append(cloneSlides)
        const limitDots = true

        if ($allSlides.length > 1) {
          $contentMob.on('afterChange', (e, slick, currentSlide) => {
            const $slideCode = $($allSlides[currentSlide]).attr('data-code-item')
            const $tabCode = $('.active.category-label')[0]

            if ($slideCode !== $($tabCode).attr('data-code')) {
              const $tabToActive = $(`[data-code="${$slideCode}"]`)

              $tabs.removeClass('active')
              $tabs.attr('aria-selected', 'false')
              $tabToActive.addClass('active')
            }
          })

          if (!$contentMob.hasClass('slick-initialized')) {
            renderSlider($contentMob, $allSlides.length, limitDots)
          } else {
            resizeHandlerInit($contentMob, $allSlides.length, limitDots)
          }
        }

        $categories.click((e) => {
          e.preventDefault()
          const $tab = $(e.target).closest('.category').find('.category-label')
          const $tabCode = $tab.attr('data-code')
          const $neededCodeSlides = $container.find(`[data-code-item="${$tabCode}"]`).parents('.slick-slide')
          const slideIndex = $($neededCodeSlides[$neededCodeSlides.length - 1]).attr('data-slick-index')
          const $slider = $('.slick-initialized', $container)

          if (window.innerWidth <= 568) {
            $slider.slick('slickGoTo', slideIndex, true)
          }
        })

      } else { //desktop
        const $categories = $container.find('.categories')
        const limitDots = false
        const $activTabOnResize = $('#tab-1', $container)
        cloneSlides={}

        $activTabOnResize.trigger('click')

        if ($slidesNumberInitial.length > 6) {
          renderSlider($contentInitial, $slidesNumberInitial, limitDots)
        }

        $categories.click((e) => {
          e.preventDefault()
          const $tab = $(e.target).closest('.category').find('.category-label')
          const $tabId = $tab.attr('data-tab')
          const $content = $container.find(`.${$tabId}`)
          const $slidesNumber = $content.find('.place--item')

          if (window.innerWidth > 568) {
            $tabs.removeClass('active')
            $tabs.attr('aria-selected', 'false')
            $container.find('.places').removeClass('active')
            $tab.addClass('active')
            $tab.attr('aria-selected', 'true')

            $content.addClass('active')

            $tabsContents.each((index, tab)=> {
              const $tab = $(tab)

              if($tab.hasClass('slick-initialized')) {
                removeSlider($tab)
              }
            })

            if($slidesNumber.length > 6) {
              renderSlider($content, $slidesNumber, limitDots)
            }
          }

          if (typeof callback === 'function') {
            callback()
          }
        })

        resizeHandlerInit($contentInitial, $slidesNumberInitial, limitDots)
      }
    }

    const mq = window.matchMedia('(max-width: 568px)')
    mq.addListener(windowWidth)
    windowWidth(mq)

    $container.find('.categories').on("keydown", function (e) {
      const code = e.keyCode || e.wich
      const $tab = $(e.target).closest('.category').find('.category-label')

      if (code === 32 || code === 13) {
        e.preventDefault()
        $tab.trigger('click')
      }
    })
  })
}
